import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-delete\"><path d=\"M7.5 7.5h1.25V15H7.5V7.5Zm3.75 0h1.25V15h-1.25V7.5Z\" /><path d=\"M2.5 3.75V5h1.25v12.5A1.25 1.25 0 0 0 5 18.75h10a1.25 1.25 0 0 0 1.25-1.25V5h1.25V3.75h-15ZM5 17.5V5h10v12.5H5ZM7.5 1.25h5V2.5h-5V1.25Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol